import React, { useState } from 'react';
import {
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
  InputAdornment,
  Card,
  CardContent,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import api from '../../../services/api/api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async () => {
    try {
      
      const response = await api.post('api/login', { email, password });

      if (response.status === 200) {
        
        const token = response.data.token; 
        const role = response.data.user.role;
        localStorage.setItem('token', token); 
        localStorage.setItem('role', role); 
        console.log('Login bem-sucedido:', response.data);
        
        window.location.href = '/admin';
      }
    } catch (error) {
      console.error('Erro ao realizar login:', error);
      setErrorMessage('Email ou senha incorretos. Tente novamente.'); 
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Card sx={{ width: 350, padding: 2, borderRadius: 2, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" textAlign="center" fontWeight="bold" mb={2}>
            Bem-vindo ao painel administrativo
          </Typography>

          {errorMessage && (
            <Typography color="error" textAlign="center" mb={2}>
              {errorMessage}
            </Typography>
          )}

          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Password"
            variant="outlined"
            fullWidth
            type={showPassword ? 'text' : 'password'}
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePasswordVisibility}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            fullWidth
            variant="contained"
            sx={{
              mt: 2,
              background: 'linear-gradient(90deg, #1cb5e0, #000851)',
              color: '#fff',
              padding: '10px',
              textTransform: 'none',
              fontWeight: 'bold',
            }}
            onClick={handleLogin}
          >
            Login
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;
